import { connect } from 'react-redux';
import TokenExpireDialog from './component';
import { clearTokenRefreshTimeout, closeSessionExpireDialog, logout } from '../../actions';

const mapStateToProps = (state) => ({ ...state.login });

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
  stay: () => dispatch(closeSessionExpireDialog()),
  clearTimeout: () => dispatch(clearTokenRefreshTimeout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TokenExpireDialog);
